<template>
  <footer class="site-footer">
    <div class="top">
      <div class="content-max-width flex">
        <div class="col-1">
          <a :href="`tel:${phone}`" class="tel">{{ phone }}</a>
          <p class="address">
            17 Maurice Road, Penrose, <br>
            P.O. Box 12252, Penrose, Auckland
          </p>
            <div class="flex">
                <a :href="facebook" class="social" target="_blank"><img src="/images/fb.svg" alt="Facebook"></a>
                <a :href="linkedin" v-if="linkedin" class="social" target="_blank"><img src="/images/linkedin.svg" alt="LinkedIn"></a>
            </div>

        </div>
        <div class="col-2 flex tablet-up">
          <ul>
            <li><a href="/about-us">ABOUT US</a></li>
            <li><a href="/our-team">OUR TEAM</a></li>
            <li><a href="/services">SERVICES</a></li>
            <li><a href="/projects">PROJECTS</a></li>
          </ul>
          <ul>
            <li><a href="/health-and-safety">HEALTH & SAFETY</a></li>
            <li><a href="/careers">CAREERS</a></li>
            <li><a href="/contact">CONTACT</a></li>
          </ul>
        </div>
      </div>

      <div class="content-max-width flex footer-certificates">
          <img :src="cert1" v-if="cert1 != ''">
          <img :src="cert2" v-if="cert2 != ''">
          <img :src="cert3" v-if="cert3 != ''">
          <img :src="cert4" v-if="cert4 != ''">
          <img :src="cert5" v-if="cert5 != ''">
          <img :src="cert6" v-if="cert6 != ''">
          <img :src="cert7" v-if="cert7 != ''">
      </div>

    </div>
    <div class="footer-legal">
      <div class="content-max-width flex">
        <p class="copyright">© COLL ELECTRICAL 2022</p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
          class="attribution"
        >WEB DESIGN BY BROWNPAPERBAG</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    cert1: String,
    cert2: String,
    cert3: String,
    cert4: String,
    cert5: String,
    cert6: String,
    cert7: String,
    phone: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    facebook: {
      type: String,
      required: true,
    },
    linkedin: {
     type: String,
     required: true,
    },
    instagram: {
      type: String,
      required: true,
    },
    pinterest: {
      type: String,
      required: true,
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue